import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, USER_ALREADY_REGISTERED } from '../constants';

export const signupRequest = (formData) => {
  return {
  type: SIGNUP_REQUEST,
  payload: formData,
}};

export const signupSuccess = (data) => {
  return {
  type: SIGNUP_SUCCESS,
  payload: {
    userId: data.userId,
  },
}};

export const signupFailure = (error) => {
  return {
  type: SIGNUP_FAILURE,
  payload: error,
}};

export const userAlreadyRegistered = () => {
  return {
  type: USER_ALREADY_REGISTERED,
}};
